<template>
	<!-- Vue Material Radio -->
	<!-- https://vuematerial.io/components/radio -->
	<md-radio
		v-model="model"
		:value="value"
		@change="$emit('change', $event)"
	>
		{{ label }}
	</md-radio>
</template>

<script>
export default {
	name: "Radio",
	props: {
		label: {
			type: String,
			required: true
		},
		value: {
			type: [String, Number, Boolean],
			required: true
		}
	},
	computed: {
		// computed prop that gets and sets value on parent and is passed down as model to md-radio component
		model: {
			get() {
				return this.$parent.value;
			},
			set(newValue) {
				this.$parent.$emit("input", newValue);
			}
		}
	}
};
</script>
